import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import dskRatings from "../../../../src/data/articles/cube-prospective-duskmourn-house-of-horror/dsk-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  dskRatings,
  ProspectiveIntro,
  React
};